import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Descriptions } from 'antd';
import moment from 'moment';
import './styles.scss';
import { config } from 'config/config';

interface UserInfoProps {
    user: {
        name: string;
        surname: string;
        email: string;
        updatedAt?: string | null;
        blockedAt?: string | null;
    };
}
const UserInfo: React.FC<UserInfoProps> = ({ user }) => {
    const label = (labelId: string) => <FormattedMessage id={labelId} />;

    const formatDateTime = (value?: string | null): string => {
        if (!value) {
            return '-';
        }

        const date = moment(value);

        return date.isValid() ? date.format(config.defaultFullDateFormat) : '-';
    };

    return (
        <div className="user-info">
            <div className="user-info-details">
                <Descriptions column={1}>
                    <Descriptions.Item label={label('general.name')}>{user.name}</Descriptions.Item>

                    <Descriptions.Item label={label('general.last_name')}>
                        {user.surname}
                    </Descriptions.Item>

                    <Descriptions.Item label={label('general.email')}>
                        {user.email}
                    </Descriptions.Item>
                </Descriptions>
            </div>

            <div className="user-info-status">
                <Descriptions column={1}>
                    <Descriptions.Item label={label('general.updated_at')}>
                        {formatDateTime(user.updatedAt)}
                    </Descriptions.Item>

                    {user?.blockedAt ? (
                        <Descriptions.Item label={label('general.blocked_at')}>
                            {formatDateTime(user.blockedAt)}
                        </Descriptions.Item>
                    ) : null}
                </Descriptions>
            </div>
        </div>
    );
};

export default UserInfo;
